export { default, type OrganizeSimpleSectionProps } from './OrganizeSimpleSection';
